/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers';
import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PromiseOrValue } from '../common';
import type { PolicyWallet, PolicyWalletInterface } from '../PolicyWallet';

const _abi = [
  {
    inputs: [
      {
        internalType: 'contract ERC20',
        name: '_cashToken',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [],
    name: 'FeeSetting',
    type: 'error',
  },
  {
    inputs: [],
    name: 'Init',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidAmt',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidOrderBookIndex',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidToNumShares',
    type: 'error',
  },
  {
    inputs: [],
    name: 'NoBalance',
    type: 'error',
  },
  {
    inputs: [],
    name: 'NotOwner',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'claimer',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'ClaimPayout',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'policy',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amtPerShare',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'totalShares',
        type: 'uint256',
      },
    ],
    name: 'NewPayouts',
    type: 'event',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'UserBalances',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'cashToken',
    outputs: [
      {
        internalType: 'contract ERC20',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'claimPayout',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'currentCashBalance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'factory',
    outputs: [
      {
        internalType: 'contract MerkleOrderbookFactory',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_factory',
        type: 'address',
      },
    ],
    name: 'init',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'orderBookIndex',
        type: 'uint256',
      },
      {
        internalType: 'address[]',
        name: '_to',
        type: 'address[]',
      },
      {
        internalType: 'uint256[]',
        name: 'numShares',
        type: 'uint256[]',
      },
      {
        internalType: 'uint256',
        name: 'amtPerShare',
        type: 'uint256',
      },
    ],
    name: 'newPayouts',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

const _bytecode =
  '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';

type PolicyWalletConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: PolicyWalletConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class PolicyWallet__factory extends ContractFactory {
  constructor(...args: PolicyWalletConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = 'PolicyWallet';
  }

  override deploy(
    _cashToken: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<PolicyWallet> {
    return super.deploy(_cashToken, overrides || {}) as Promise<PolicyWallet>;
  }
  override getDeployTransaction(
    _cashToken: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_cashToken, overrides || {});
  }
  override attach(address: string): PolicyWallet {
    return super.attach(address) as PolicyWallet;
  }
  override connect(signer: Signer): PolicyWallet__factory {
    return super.connect(signer) as PolicyWallet__factory;
  }
  static readonly contractName: 'PolicyWallet';

  public readonly contractName: 'PolicyWallet';

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PolicyWalletInterface {
    return new utils.Interface(_abi) as PolicyWalletInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): PolicyWallet {
    return new Contract(address, _abi, signerOrProvider) as PolicyWallet;
  }
}
